/** Wer in der laufenden Sitzung angemeldet ist - dieselben vier Werte, die checkSession liefert. */
export interface LoginContext {
  customerNumber: string;
  userName: string;
  contactId: number | null;
  locale: string;
}

let current: LoginContext | undefined;

/**
 * Der Login-Kontext der laufenden Sitzung, gehalten als Modulzustand.
 *
 * Gesetzt, sobald `checkSession` ihn kennt, gelesen erst, wenn ein Modul danach fragt: die
 * Kommunikation wird beim Modulladen registriert, da gibt es noch keine Sitzung.
 */
export function setLoginContext(context: LoginContext): void {
  current = context;
}

export function getLoginContext(): LoginContext | undefined {
  return current;
}
